import { Chip, type ChipSize } from "./Chip";

export interface NewSoonBadgeProps {
  /**
   * Localized label text (e.g. "(New Soon)" or "(قريباً)"). Required so
   * `@a2z/ui` stays i18n-agnostic — each host app passes its translated string.
   */
  label: string;
  size?: ChipSize;
  className?: string;
}

/**
 * Small amber pill that flags a section or field as a preview of an upcoming
 * feature. The label is always provided by the host app so this primitive
 * has no i18n dependency.
 */
export function NewSoonBadge({
  label,
  size = "sm",
  className,
}: NewSoonBadgeProps) {
  return (
    <Chip
      tone="accent"
      size={size}
      className={[
        "uppercase tracking-wide !text-[7px] !leading-none",
        className ?? "",
      ]
        .join(" ")
        .trim()}
    >
      {label}
    </Chip>
  );
}
